import { useAsyncJob } from './useAsyncJob';

interface ScoreCalculationJob {
  id: string;
  feed_id: string;
  user_id: string;
  status: 'queued' | 'processing' | 'completed' | 'failed';
  total_products: number;
  scored_products: number;
  failed_products: number;
  queued_batches: number;
  processed_batches: number;
  created_at: string;
  completed_at: string | null;
}

/**
 * Subscribes to score_calculation_jobs for the given feed.
 * Frontend should pass `enabled = true` only after the optimization job has completed.
 */
export function useScoringJob(feedId: string | null, enabled: boolean) {
  const { activeJob, cancelJob, invalidate } = useAsyncJob<ScoreCalculationJob>({
    tableName: 'score_calculation_jobs',
    channelName: 'progress-modal-score-job',
    queryKeyPrefix: 'progress-modal-score-job',
    // Die Queue waehlt der Server (cancel_async_job, WP0/K01). Frueher stand hier
    // 'score_queue', eine Queue, die es nie gab (S5-N1).
    feedId: enabled ? feedId : null,
    forcePolling: enabled,
  });

  const scoreProgressPct = activeJob && activeJob.total_products > 0
    ? Math.round((activeJob.scored_products / activeJob.total_products) * 100)
    : 0;

  return {
    activeScoreJob: activeJob,
    scoreProgressPct,
    cancelScoreJob: cancelJob,
    invalidateScoreJob: invalidate,
  };
}
